/* Local draft only. Validate in a draft theme before upload. */
(function () {
  var windows = {
    dry: {
      minCalendarDays: 1,
      maxCalendarDays: 4,
      state: 'ready',
      note: 'Dry goods estimate; holidays may shift.',
      bucket: 'dry_24h_1_4d'
    },
    frozen: {
      transitCalendarDays: 2,
      state: 'cold-chain',
      note: 'Ships Mon-Wed with 2-day cold-chain transit.',
      bucket: 'cold_24h_mon_wed_2day'
    },
    refrigerated: {
      transitCalendarDays: 2,
      state: 'cold-chain',
      note: 'Ships Mon-Wed with 2-day cold-chain transit.',
      bucket: 'cold_24h_mon_wed_2day'
    },
    unknown: {
      state: 'unknown',
      note: '',
      bucket: 'unknown'
    }
  };

  var coldShipDays = [1, 2, 3];
  var handlingCalendarDays = 1;
  var storageKey = 'rs_arrive_by_zip';
  var currentZip = '';
  var gridObserver = null;
  var productObserver = null;
  var renderQueued = false;

  function transitTable() {
    return window.RS_ARRIVE_BY_TRANSIT_TIMES || {};
  }

  function defaultTransitRule() {
    var tableDefault = transitTable().default || {};
    return {
      dryMinCalendarDays: Number(tableDefault.dryMinCalendarDays) || windows.dry.minCalendarDays,
      dryMaxCalendarDays: Number(tableDefault.dryMaxCalendarDays) || windows.dry.maxCalendarDays,
      coldTransitCalendarDays: Number(tableDefault.coldTransitCalendarDays) || Number(tableDefault.coldTransitBusinessDays) || windows.frozen.transitCalendarDays,
      coldShipDays: Array.isArray(tableDefault.coldShipDays) && tableDefault.coldShipDays.length ? tableDefault.coldShipDays : coldShipDays,
      source: 'default'
    };
  }

  function mergeTransitRule(base, override, source) {
    if (!override) return base;
    return {
      dryMinCalendarDays: Number(override.dryMinCalendarDays) || base.dryMinCalendarDays,
      dryMaxCalendarDays: Number(override.dryMaxCalendarDays) || base.dryMaxCalendarDays,
      coldTransitCalendarDays: Number(override.coldTransitCalendarDays) || Number(override.coldTransitBusinessDays) || base.coldTransitCalendarDays,
      coldShipDays: Array.isArray(override.coldShipDays) && override.coldShipDays.length ? override.coldShipDays : base.coldShipDays,
      source: source
    };
  }

  function sanitizeZip(value) {
    var digits = String(value || '').replace(/\D/g, '');
    return digits.length >= 5 ? digits.slice(0, 5) : '';
  }

  function transitRuleForZip(zip) {
    var table = transitTable();
    var rule = defaultTransitRule();
    var cleanZip = sanitizeZip(zip);
    if (!cleanZip) return rule;
    if (table.zip3 && table.zip3[cleanZip.slice(0, 3)]) {
      rule = mergeTransitRule(rule, table.zip3[cleanZip.slice(0, 3)], 'zip3');
    }
    if (Array.isArray(table.zip5Ranges)) {
      var rangeRule = transitRuleFromRanges(cleanZip, table.zip5Ranges);
      if (rangeRule) {
        rule = mergeTransitRule(rule, rangeRule, 'zip5_range');
      }
    }
    if (table.zip5 && table.zip5[cleanZip]) {
      rule = mergeTransitRule(rule, table.zip5[cleanZip], 'zip5');
    }
    return rule;
  }

  function transitRuleFromRanges(zip, ranges) {
    var zipNumber = Number(zip);
    var low = 0;
    var high = ranges.length - 1;
    while (low <= high) {
      var mid = Math.floor((low + high) / 2);
      var range = ranges[mid];
      var start = Number(range[0]);
      var end = Number(range[1]);
      if (zipNumber < start) {
        high = mid - 1;
      } else if (zipNumber > end) {
        low = mid + 1;
      } else {
        var days = Number(range[2]);
        if (!Number.isFinite(days) || days < 0) return null;
        return {
          dryMinCalendarDays: days,
          dryMaxCalendarDays: days,
          coldTransitCalendarDays: days,
          coldShipDays: range[3] || coldShipDays
        };
      }
    }
    return null;
  }

  function getStoredZip() {
    try {
      return sanitizeZip(window.localStorage && window.localStorage.getItem(storageKey));
    } catch (error) {
      return '';
    }
  }

  function storeZip(zip) {
    try {
      if (zip) {
        window.localStorage && window.localStorage.setItem(storageKey, zip);
      } else {
        window.localStorage && window.localStorage.removeItem(storageKey);
      }
    } catch (error) {
      // localStorage may be unavailable in preview or privacy contexts.
    }
  }

  function isBusinessDay(date) {
    var day = date.getDay();
    return day !== 0 && day !== 6;
  }

  function addBusinessDays(startDate, days) {
    var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 12, 0, 0, 0);
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (isBusinessDay(date)) added += 1;
    }
    return date;
  }

  function addCalendarDays(startDate, days) {
    var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 12, 0, 0, 0);
    date.setDate(date.getDate() + days);
    return date;
  }

  function nextColdShipDate(startDate, shipDays) {
    var allowedDays = Array.isArray(shipDays) && shipDays.length ? shipDays : coldShipDays;
    var date = addCalendarDays(startDate, 0);
    while (allowedDays.indexOf(date.getDay()) === -1) {
      date.setDate(date.getDate() + 1);
    }
    return date;
  }

  function formatDate(date) {
    var currentYear = new Date().getFullYear();
    var options = {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    };
    if (date.getFullYear() !== currentYear) options.year = 'numeric';
    return date.toLocaleDateString(undefined, options);
  }

  function formatDateRange(startDate, endDate) {
    return formatDate(startDate) + '-' + formatDate(endDate);
  }

  function normalizeBucket(value) {
    var bucket = String(value || '').toLowerCase();
    if (bucket === 'frozen' || bucket === 'refrigerated' || bucket === 'dry') return bucket;
    return 'unknown';
  }

  function isAvailable(value) {
    return String(value || '').toLowerCase() === 'true';
  }

  function renderEstimate(node, zip) {
    var dateEl = node.querySelector('[data-rs-arrive-by-date]');
    var noteEl = node.querySelector('[data-rs-arrive-by-note]');
    if (!dateEl) return;

    if (!isAvailable(node.getAttribute('data-rs-product-available'))) {
      dateEl.textContent = 'View product for availability';
      if (noteEl) noteEl.textContent = '';
      node.setAttribute('data-rs-arrive-by-state', 'unavailable');
      node.setAttribute('data-rs-arrive-by-window', 'unavailable');
      return;
    }

    var temperatureBucket = normalizeBucket(node.getAttribute('data-rs-temperature-bucket'));
    var config = windows[temperatureBucket] || windows.unknown;
    var transitRule = transitRuleForZip(zip);
    var now = new Date();

    if (temperatureBucket === 'unknown') {
      dateEl.textContent = 'View product for estimate';
      if (noteEl) noteEl.textContent = '';
      node.setAttribute('data-rs-arrive-by-state', config.state);
      node.setAttribute('data-rs-arrive-by-window', config.bucket);
      return;
    }

    if (temperatureBucket === 'dry') {
      var readyDate = addCalendarDays(now, handlingCalendarDays);
      var dryMinDays = transitRule.dryMinCalendarDays || config.minCalendarDays;
      var dryMaxDays = transitRule.dryMaxCalendarDays || config.maxCalendarDays;
      var startDate = addCalendarDays(readyDate, dryMinDays);
      var endDate = addCalendarDays(readyDate, dryMaxDays);
      dateEl.textContent = dryMinDays === dryMaxDays ? 'Est. by ' + formatDate(endDate) : 'Est. ' + formatDateRange(startDate, endDate);
      if (noteEl) noteEl.textContent = '';
      node.setAttribute('data-rs-arrive-by-state', config.state);
      node.setAttribute('data-rs-arrive-by-window', dryMinDays === dryMaxDays ? 'dry_24h_' + dryMaxDays + 'd' : 'dry_24h_' + dryMinDays + '_' + dryMaxDays + 'd');
      node.setAttribute('data-rs-arrive-by-transit-source', transitRule.source);
      node.setAttribute('data-rs-handling-date-value', readyDate.toISOString().slice(0, 10));
      node.setAttribute('data-rs-arrive-by-date-start', startDate.toISOString().slice(0, 10));
      node.setAttribute('data-rs-arrive-by-date-end', endDate.toISOString().slice(0, 10));
      return;
    }

    var coldReadyDate = addCalendarDays(now, handlingCalendarDays);
    var shipDate = nextColdShipDate(coldReadyDate, coldShipDays);
    var transitDays = config.transitCalendarDays || windows.frozen.transitCalendarDays;
    var arriveByDate = addCalendarDays(shipDate, transitDays);

    dateEl.textContent = 'Est. by ' + formatDate(arriveByDate);
    if (noteEl) noteEl.textContent = '24-hour handling; ships Mon-Wed with ' + transitDays + '-day cold-chain transit.';
    node.setAttribute('data-rs-arrive-by-state', config.state);
    node.setAttribute('data-rs-arrive-by-window', 'cold_24h_mon_wed_' + transitDays + 'day');
    node.setAttribute('data-rs-arrive-by-transit-source', 'cold_fixed_2day');
    node.setAttribute('data-rs-handling-date-value', coldReadyDate.toISOString().slice(0, 10));
    node.setAttribute('data-rs-ship-date-value', shipDate.toISOString().slice(0, 10));
    node.setAttribute('data-rs-arrive-by-date-value', arriveByDate.toISOString().slice(0, 10));
  }

  function initArriveBy() {
    var nodes = document.querySelectorAll('[data-rs-arrive-by="true"]');
    nodes.forEach(function (node) {
      renderEstimate(node, currentZip);
    });
  }

  function scheduleArriveByRender() {
    if (renderQueued) return;
    renderQueued = true;
    window.requestAnimationFrame(function () {
      renderQueued = false;
      initArriveBy();
    });
  }

  function setZipStatus(control, zip, valid) {
    var status = control.querySelector('[data-rs-arrive-by-zip-status]');
    if (!status) return;
    if (!zip && valid) {
      status.textContent = 'Using default transit estimate';
      return;
    }
    status.textContent = valid ? 'Using ZIP ' + zip : 'Enter a 5-digit ZIP';
  }

  function applyZip(control, rawZip, persist) {
    var zip = sanitizeZip(rawZip);
    var input = control.querySelector('[data-rs-arrive-by-zip-input]');
    if (!zip && rawZip) {
      setZipStatus(control, '', false);
      return;
    }
    currentZip = zip;
    if (input) input.value = zip;
    if (persist) storeZip(zip);
    setZipStatus(control, zip, true);
    initArriveBy();
  }

  function initZipControls() {
    currentZip = getStoredZip();
    var controls = document.querySelectorAll('[data-rs-arrive-by-zip-control]');
    controls.forEach(function (control) {
      var input = control.querySelector('[data-rs-arrive-by-zip-input]');
      var button = control.querySelector('[data-rs-arrive-by-zip-apply]');
      if (input && currentZip) input.value = currentZip;
      setZipStatus(control, currentZip, true);
      if (control.getAttribute('data-rs-arrive-by-zip-bound') === 'true') return;
      control.setAttribute('data-rs-arrive-by-zip-bound', 'true');
      if (button) {
        button.addEventListener('click', function () {
          applyZip(control, input ? input.value : '', true);
        });
      }
      if (input) {
        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            applyZip(control, input.value, true);
          }
        });
      }
    });
  }

  function initGridObserver() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || !window.MutationObserver) return;
    if (gridObserver) gridObserver.disconnect();
    gridObserver = new MutationObserver(function (mutations) {
      var shouldRender = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length;
      });
      if (shouldRender) scheduleArriveByRender();
    });
    gridObserver.observe(container, { childList: true, subtree: true });
  }

  function elementForMutationNode(node) {
    if (!node) return null;
    if (node.nodeType === 1) return node;
    return node.parentElement || null;
  }

  function isDeliveryModuleMutation(mutation) {
    var targetElement = elementForMutationNode(mutation.target);
    if (targetElement && targetElement.closest && targetElement.closest('[data-rs-product-delivery="true"]')) return true;

    var nodes = Array.prototype.slice.call(mutation.addedNodes || []).concat(Array.prototype.slice.call(mutation.removedNodes || []));
    return nodes.some(function (node) {
      var element = elementForMutationNode(node);
      return element && element.closest && element.closest('[data-rs-product-delivery="true"]');
    });
  }

  function initProductObserver() {
    var productInfo = document.querySelector('product-info');
    if (!productInfo || !window.MutationObserver) return;
    if (productObserver) productObserver.disconnect();
    productObserver = new MutationObserver(function (mutations) {
      var shouldRender = mutations.some(function (mutation) {
        if (isDeliveryModuleMutation(mutation)) return false;
        return mutation.addedNodes && mutation.addedNodes.length;
      });
      if (shouldRender) {
        initZipControls();
        scheduleArriveByRender();
      }
    });
    productObserver.observe(productInfo, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initZipControls();
      initArriveBy();
      initGridObserver();
      initProductObserver();
    }, { once: true });
  } else {
    initZipControls();
    initArriveBy();
    initGridObserver();
    initProductObserver();
  }
}());
